export enum CodeInputData {
  title = "title",
  subtitle = "subtitle",
  codeSnippet = "codeSnippet",
  gistUrl = "gistUrl",
}
